export enum CreditNoteType {
    Accepted = 'ACCEPTED',
    NoAgree = 'NO_AGREE'
}
